import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function BlueprintImageLightbox({ imageUrl, alt, isOpen, onClose }) {
    const { t } = useTranslation();

    useEffect(() => {
        if (!isOpen) return;
        const handler = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handler);
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", handler);
            document.body.style.overflow = prevOverflow;
        };
    }, [isOpen, onClose]);

    if (!isOpen || !imageUrl) return null;

    return createPortal(
        <div
            role="dialog"
            aria-modal="true"
            aria-label={t("blueprints.imagePreview", "Image preview")}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 backdrop-blur-sm animate-in fade-in duration-150"
            onClick={onClose}
        >
            <button
                type="button"
                onClick={onClose}
                aria-label={t("common.close", "Close")}
                className="absolute top-4 right-4 z-10 rounded-full p-2 bg-white/10 hover:bg-white/20 text-white transition-colors"
            >
                <X className="h-5 w-5" />
            </button>
            <img
                src={imageUrl}
                alt={alt || ""}
                onClick={(e) => e.stopPropagation()}
                className="max-w-[92vw] max-h-[88vh] w-auto h-auto object-contain rounded-md shadow-2xl cursor-default select-none"
            />
        </div>,
        document.body
    );
}
